// import React from "react";
import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Dialog, Grid, Typography } from '@mui/material';
import { TCLabel, TCTitleLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import { currencyFormat } from "helper/NumberFormat";
import { fontSize } from "@mui/system";

import icon from "../../../assets/money-in.png";
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { checkIsSAdmin, isMerchant } from 'helper/Admin';
import { createMerchantDeposit } from 'services/merchantServices';
import MerchantDeposit from '../merchant/component/merchantDeposit';
import { Divider } from '@mui/material';
import { getMerchantDepositList } from "services/merchantServices";
import { toast } from 'react-toastify';
import { getUrlCourtCode } from 'helper/Court';

const initFilter = {
    page: 0,
    limit: 20,
}

export default function PaymentSummmary({
    summary, hideInfo = false
}) {

    const [openTopUp, setOpenTopUp] = useState(false);
    const [topUpAmount, setTopUpAmount] = useState('');
    const [merchantBalance, setMerchantBalance] = useState('');
    const [merchantDepositList, setMerchantDepositList] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [filter, setFilter] = useState(initFilter)
    const merchantId = isMerchant();

    useEffect(() => {
        console.log('here summary', summary)
        setMerchantBalance(summary.merchantBalance || 0)
    }, [summary])

    const handleClose = () => {
        setOpenTopUp(false);
    };

    const topUp = async (amount) => {
        try {
            let { data, error } = await createMerchantDeposit({
                deposit: amount
            })
            if (error) throw error;
            if (data) {
                toast.success("Top up requested. Pending approval");
                loadMerchantDepositRequest();
            }
        } catch (e) {
            console.error(e);
            toast.error("Request failed. Please try again later");
        }
    }

    useEffect(() => {
        if (merchantId) {
            loadMerchantDepositRequest();
        }
    }, [filter])

    const loadMerchantDepositRequest = async () => {
        let { data, error } = await getMerchantDepositList({
            merchantId: merchantId,
            isClosed: '',
            page: filter.page,
            limit: filter.limit
        });
        if (data) {
            setMerchantDepositList(data.merchantDeposit)
            setTotalData(data.totalData)
        }
    }

    const styles = {
        summary: {
            minWidth: 50,
            height: 50,
            opacity: '0.3',
            marginLeft: 10,
            background: `url(${icon}) no-repeat top right`,
            backgroundSize: 'contain',
            marginRight: 10
        }
    }

    return (
        <Card sx={{ mb: 1 }} className="custom-card-style">
            <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <div style={{
                    justifyContent: 'space-between', alignItems: 'center',
                    display: 'flex'
                }}>
                    <div style={{ width: '100%' }}>
                        <Grid container columnSpacing={2} sx={{ p: 2, alignItems: 'center' }}>
                            <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                <Card sx={{
                                    justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', height: 80, padding: 1, borderRadius: 0,
                                    borderLeft: '5px solid rgb(66, 181, 73)'
                                }}>
                                    <TCLabel style={{
                                        fontSize: 12,
                                        color: 'rgb(133, 133, 133)'
                                    }}>Grand Total</TCLabel>
                                    <TCLabel bold style={{
                                        fontSize: 15
                                    }}>{`${summary && summary.grandTotal ? currencyFormat(summary.grandTotal) : '-'}`}</TCLabel>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                <Card sx={{
                                    justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', minHeight: 80, padding: 1, borderRadius: 0,
                                    borderLeft: '5px solid rgb(66, 181, 73)'
                                }}>
                                    <TCLabel style={{
                                        fontSize: 12,
                                        color: 'rgb(133, 133, 133)'
                                    }}>{`Total Payment (${getUrlCourtCode().toUpperCase()} ${getUrlCourtCode().toUpperCase() == "TB" ? "QR" : "HO"}) :`}</TCLabel>
                                    <TCLabel bold style={{
                                        fontSize: 15
                                    }}>{`${summary && summary.totalSTCHO && summary.totalSTCHO.totalOrder > 0 ? currencyFormat(summary.totalSTCHO.totalOrder) : '-'}`}</TCLabel>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                <Card sx={{
                                    justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', minHeight: 80, padding: 1, borderRadius: 0,
                                    borderLeft: '5px solid rgb(66, 181, 73)'
                                }}>
                                    <TCLabel style={{
                                        fontSize: 12,
                                        color: 'rgb(133, 133, 133)'
                                    }}>Total Payment (QRIS) :</TCLabel>
                                    <TCLabel bold style={{
                                        fontSize: 15
                                    }}>{`${summary && summary.totalQRIS ? summary.totalQRIS.totalOrder > 0 ? currencyFormat(summary.totalQRIS.totalOrder) : '-' : '-'}`}</TCLabel>
                                </Card>
                            </Grid>
                            {
                                isMerchant() &&
                                <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                    <Card sx={{
                                        justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', minHeight: 80, padding: 1, borderRadius: 0,
                                        borderLeft: '5px solid rgb(66, 181, 73)'
                                    }}>
                                        <TCLabel style={{
                                            fontSize: 12,
                                            color: 'rgb(133, 133, 133)'
                                        }}>Total VP Amount :</TCLabel>
                                        <TCLabel bold style={{
                                            fontSize: 15
                                        }}>{`${summary && summary.totalVPAmount ? summary.totalVPAmount > 0 ? currencyFormat(summary.totalVPAmount) : '-' : '-'}`}</TCLabel>
                                    </Card>
                                </Grid>
                            }
                            {
                                (isMerchant() && !hideInfo) &&
                                <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                    <Card sx={{
                                        justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', minHeight: 80, padding: 1, borderRadius: 0,
                                        borderLeft: '5px solid rgb(66, 181, 73)'
                                    }}>
                                        <TCLabel style={{
                                            fontSize: 12,
                                            color: 'rgb(133, 133, 133)'
                                        }}>Total Txn Fee :</TCLabel>
                                        <TCLabel bold style={{
                                            fontSize: 15
                                        }}>{`${summary && summary.totalTXNFee ? summary.totalTXNFee > 0 ? currencyFormat(summary.totalTXNFee) : '-' : '-'}`}</TCLabel>
                                    </Card>
                                </Grid>
                            }
                        </Grid>
                    </div>
                    {
                        !hideInfo &&
                        <div style={styles.summary}></div>
                    }
                </div>
            </Box>
        </Card>
    )
}